import { Product } from "../catalog/product.model";
import { PaymentOption } from "../order/payment-option.model";
import { ShippingOption } from "../order/shipping-option.model";
import { Address } from "./address.model";
import { OrderTotals } from "./order-totals.model";

export class Customer {
  email: string;
  customerGuid: string;
  compareList: Product[];
  wishList: Product[];
  cartList: Product[];
  orderTotals: OrderTotals;
  discountCodes: string[];
  discountMessages: string [];
  giftCardMessage: string;
  totalCartCount: number;
  totalWishlistCount: number;
  gridView: string;
  warnings: string[];
  shippingAddress: Address;
  billingAddress: Address;
  additionalAddresses: Address[];
  selectedShippingType: ShippingOption;
  selectedPaymentType: PaymentOption;
  updatingCart: boolean;

  // Attributes
  timeZoneId: number;
  gender: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  company: string;
  countryId: number;
  stateProvinceId: number;
  county: string;
  city: string;
  streetAddress1: string;
  streetAddress2: string;
  zipPostalCode: string;
  phone: string;
  fax: string;
}
